var map = {
	"./card.svg": "2d9e",
	"./close.svg": "7710",
	"./code.svg": "d7a5",
	"./collect1.svg": "5686",
	"./collect2.svg": "a5f1",
	"./cooper.svg": "22f9",
	"./edit.svg": "aa46",
	"./eye-close.svg": "efcd",
	"./eye.svg": "4df5",
	"./guard.svg": "0174",
	"./house.svg": "4147",
	"./house_select.svg": "91fb",
	"./icon1.svg": "5e30",
	"./icon2.svg": "5018",
	"./icon3.svg": "68f1",
	"./icon4.svg": "edca",
	"./icon5.svg": "9282",
	"./icon6.svg": "e497",
	"./icon_invite_new.svg": "7e9b",
	"./identify.svg": "ff60",
	"./kefu.svg": "0063",
	"./line.svg": "4b7d",
	"./location.svg": "1c50",
	"./medal.svg": "428d",
	"./order.svg": "11ff",
	"./order_select.svg": "b995",
	"./person.svg": "a450",
	"./person_select.svg": "4e5f",
	"./phone.svg": "dd82",
	"./plane-2.svg": "3341",
	"./plane.svg": "4b6e",
	"./protect.svg": "7945",
	"./smell.svg": "b717",
	"./smell_select.svg": "7a07",
	"./sound_left.svg": "8d6c",
	"./sound_right.svg": "1983",
	"./tel.svg": "2315",
	"./ticket.svg": "b38e",
	"./unlike.svg": "8100",
	"./vip.svg": "1296",
	"./wechat.svg": "80da",
	"./wechat_round.svg": "ea87",
	"./wx.svg": "ddee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";